import React from 'react'
import UserLogin from '../../Components/User/UserLogin'

function UserLoginpage() {
  return (
    <div>
      <UserLogin/>
    </div>
  )
}

export default UserLoginpage
